import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2356ddc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-search"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "search-text"
}, "搜索", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createBlock(_component_el_input, {
    modelValue: _ctx.inputValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.inputValue = $event),
    placeholder: _ctx.placeholder,
    class: "t-input__search",
    "trigger-on-focus": false,
    onInput: _ctx.handleInput,
    onKeypress: _withKeys(_ctx.handleSearch, ["enter"])
  }, {
    suffix: _withCtx(() => [_withDirectives(_createElementVNode("i", {
      class: "t-icon t-icon-close",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.clearSearch && _ctx.clearSearch(...args))
    }, null, 512), [[_vShow, _ctx.inputValue !== '']]), _createVNode(_component_el_button, {
      type: "",
      text: "",
      class: "t-input__search-btn",
      onClick: _ctx.handleSearch
    }, {
      default: _withCtx(() => [_hoisted_1, _hoisted_2]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue", "placeholder", "onInput", "onKeypress"]);
}